import { render } from "./DevBuddyColorPicker.vue?vue&type=template&id=5b9ccde2&scoped=true"
import script from "./DevBuddyColorPicker.vue?vue&type=script&lang=js"
export * from "./DevBuddyColorPicker.vue?vue&type=script&lang=js"

import "./DevBuddyColorPicker.vue?vue&type=style&index=0&id=5b9ccde2&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9ccde2"]])

export default __exports__